<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success" style="margin-bottom: 0;"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.hxShipmentJdNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.hxShipmentJdStatus == 'C'
              ? 'warning'
              : formData.hxShipmentJdStatus == 'D'
              ? 'danger'
              : formData.hxShipmentJdStatus == 'V'
              ? 'vehicle'
              : formData.hxShipmentJdStatus == 'Y'
              ? 'success'
              : ''
          "
        >
          {{ formData.v_hxShipmentJdStatus }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName }} at{{ formData.modifyDate }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_shippingDate') || '预计发运日期'"
            prop="shippingDate"
          >
            <el-date-picker
              v-model="formData.shippingDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_isUrgent') || '是否紧急'"
            prop="isUrgent"
          >
            <el-select
              v-model="formData.isUrgent"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              style="width:100%"
            >
              <el-option
                :label="$l('form_label_isUrgent_Y') || '是'"
                value="Y"
              />
              <el-option
                :label="$l('form_label_isUrgent_N') || '否'"
                value="N"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="d-flex">
            <el-form-item
              :label="$l('form_label_remark') || '备注'"
              style="flex:1"
            >
              <el-input
                v-model="formData.remark"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="500"
                clearable
                show-word-limit
              />
            </el-form-item>
            <div class="ml-2" v-if="!disabled">
              <el-form-item>
                <template #label>
                  <br />
                </template>
                <el-button type="primary" size="small" @click="save">
                  {{ $l('INDEX.btn_save') || '保存' }}
                </el-button>
                <!-- <div style="height:1px;"></div> -->
              </el-form-item>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    hxShipmentJdCode: { type: String, default: '' },
    hxShipmentJdStatus: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        shippingDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        isUrgent: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.hxShipmentJdCode) return
      const params = { hxShipmentJdCode: this.hxShipmentJdCode }
      const res = await this.$api
        .ecomHxShipmentJdDetailApi(params)
        .catch(() => null)
      this.formData = res?.body || {}
      const { hxShipmentJdStatus } = this.formData
      this.$emit('update:hxShipmentJdStatus', hxShipmentJdStatus)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxShipmentJdSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
::v-deep {
  .el-tag--vehicle {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
